import axiosInstance from "middleware/axios";

const getListPin = (params) => axiosInstance.get("/api/group/list_pin", { params });

const addPin = (params) => axiosInstance.get("/api/group/add_pin", { params });

const removePin = (params) => axiosInstance.get("/api/group/remove_pin", { params });

export { getListPin, addPin, removePin };
